import { render, staticRenderFns } from "./POD-10Report-2023AnyObject.vue?vue&type=template&id=0cd72613&scoped=true"
import script from "./POD-10Report-2023AnyObject.vue?vue&type=script&lang=js"
export * from "./POD-10Report-2023AnyObject.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cd72613",
  null
  
)

export default component.exports